"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mai = void 0;
exports.mai = {
    chef: '0x13b826B2f6317f761A9A7564053EC69B4318073f',
};
